import { ArticleSection } from 'components/ArticleSection';
import { EditorialRelatedArticlesBlock } from 'models/EditorialRelatedArticlesBlock';

export const RelatedArticles = ({ articles, sectionTitle }: EditorialRelatedArticlesBlock) => {
  return <ArticleSection sectionTitle={sectionTitle} articles={articles} />;
};
